import axios from 'axios';
import { API } from './constants';

const apiClient = axios.create({
  baseURL: API,
  headers: { 'Content-Type': 'application/json' },
});

export const submitLead = async (leadData) => {
  const response = await apiClient.post('/leads', leadData);
  return response.data;
};

export const submitContact = async (contactData) => {
  const response = await apiClient.post('/contact', contactData);
  return response.data;
};

export const subscribeNewsletter = async (email) => {
  const response = await apiClient.post('/newsletter', { email });
  return response.data;
};

export default apiClient;
